import { getJson } from '../common';

export interface EntryPoints {
    css: string[];
    js: string[];
    module?: true;
    port?: number;
}

export async function getEntrypoints(
    url: string,
    cache: 'no-store' | undefined,
    signal?: AbortSignal
): Promise<EntryPoints> {
    try {
        return (
            await getJson(url, {
                cache,
                signal,
            })
        ).data;
    } catch {
        return { css: ['index.css'], js: ['index.js'] };
    }
}
